import styled from 'styled-components';

// Single fixed root: the whole easter egg lives inside one stacking context,
// children layer by DOM order — no z-index juggling against the page.
export const Root = styled.div<{ $blockPointer: boolean }>`
	position: fixed;
	inset: 0;
	z-index: 10000;
	pointer-events: ${({ $blockPointer }) => ($blockPointer ? 'auto' : 'none')};
`;

export const Overlay = styled.div<{ $op: number }>`
	position: absolute;
	inset: 0;
	background: #3498db;
	opacity: ${({ $op }) => $op};
`;

// Shared bird wrapper (flying pig and in-game bird). Size = the physics bird
// box everywhere (PHYS.birdSize, 58/720 ≈ 8.06vh) so the landing hands over
// to the game at exactly the same apparent size.
export const BirdWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 8.06vh; 
	height: 8.06vh;
	pointer-events: auto; 
	transform-origin: center center;
	user-select: none;
	-webkit-user-select: none;
	will-change: transform;
	overflow: visible;
`;

export const BirdImg = styled.img`
	width: 100%;
	height: 100%;
	display: block;
	user-select: none;
	-webkit-user-select: none;
	draggable: none;
`;

export const Canvas = styled.canvas`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 16px;
	right: 16px;
	width: 56px;
	height: 56px;
	background: rgba(0, 0, 0, 0.45);
	border: 3px solid white;
	border-radius: 50%;
	color: white;
	font-size: 2em;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
	padding: 0;

	&:hover {
		background: rgba(0, 0, 0, 0.7);
	}
`;

export const ScoreDisplay = styled.div`
	position: absolute;
	top: 20px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 3em;
	font-weight: 700;
	color: white;
	text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
	font-family: 'Trebuchet MS', sans-serif;
	user-select: none;
	-webkit-user-select: none;
`;

export const StartPrompt = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: white;
	font-size: 1.5em;
	font-family: 'Trebuchet MS', sans-serif;
	text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
	text-align: center;
	user-select: none;
	-webkit-user-select: none;
`;

export const GameOverPanel = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background: rgba(0, 0, 0, 0.8);
	border-radius: 16px;
	padding: 40px 48px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
`;

export const GameOverTitle = styled.h2`
	color: white;
	font-size: 2em;
	margin: 0;
	font-family: 'Trebuchet MS', sans-serif;
`;

export const GameOverScore = styled.p`
	color: #ddd;
	font-size: 1.2em;
	margin: 0;
`;

export const GameOverScoreValue = styled.span`
	color: #3498db;
	font-weight: 700;
	font-size: 1.4em;
`;

export const GameOverButtons = styled.div`
	display: flex;
	gap: 16px;
	margin-top: 8px;
`;

export const GameButton = styled.button`
	padding: 12px 28px;
	border-radius: 8px;
	font-size: 1em;
	cursor: pointer;
	border: none;
	font-weight: 600;
	transition: all 0.2s ease;
`;

export const RetryButton = styled(GameButton)`
	background: #2ecc71;
	color: white;

	&:hover {
		background: #27ae60;
	}
`;

export const ExitButton = styled(GameButton)`
	background: #e74c3c;
	color: white;

	&:hover {
		background: #c0392b;
	}
`;